var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['text-red-500', _vm.containerClass],attrs:{"disabled":_vm.load && !_vm.fileKey},on:{"click":function($event){return _vm.showDetail()}}},[_vm._v(" "+_vm._s(_vm.filekey ? (_vm.load ? "Hazırlanıyor" : "Görüntüle") : "")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }